import type { Response } from '@src/utils/request'
import { fetcher } from '@src/utils/fetcher'

export async function getUserInfo(): Promise<Response> {
	return fetcher('/sys/userinfo', 'GET', { body: {} })
}

export async function saveUserInfo(body: any): Promise<Response> {
	return fetcher(`/sys/userinfo/save`, 'POST', { body: body })
}
